import React from "react";
import moment from "moment";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
const despachos_activo = require("assets/img/icons/despachos_activo.png");
const borrarIcon = require("assets/img/icons/borrar.png");
import { Link } from "react-router-dom";

export const PendientesTable = ({
    traslados,
    MostrarMensajeEliminacionTraslado,
}) => {
    return (
        <div className="new-table-wrapper listado-traslados__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th>NÚMERO</th>
                        <th>ORIGEN</th>
                        <th>DESTINO</th>
                        <th>FECHA DE CREACIÓN</th>
                        <th>PILOTO</th>
                        <th>PESO TARA</th>
                    </tr>
                </thead>
                <tbody>
                    {traslados.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center">
                                No hay traslados pendientes.
                            </td>
                        </tr>
                    )}
                    {traslados.map((item) => {
                        const tieneRecepciones =
                            item.detalles && item.detalles.length > 0;

                        const link = tieneRecepciones
                            ? `traslados/${item.id}/pesaje-traslado`
                            : `traslados/${item.id}/seleccion-recepciones`;

                        const titleButton = tieneRecepciones
                            ? "Pesar materia prima"
                            : "Seleccionar recepciones";

                        return (
                            <tr key={item.id}>
                                <td>
                                    <div className="table-actions">
                                        <img
                                            src={borrarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                MostrarMensajeEliminacionTraslado(
                                                    item.id,
                                                )
                                            }
                                        />

                                        <Link to={link} className="px-2">
                                            <img
                                                src={despachos_activo}
                                                alt={titleButton}
                                                className="action_img"
                                                title={titleButton}
                                            />
                                        </Link>
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.numero}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio_origen
                                        ? item.acopio_origen.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio_destino
                                        ? item.acopio_destino.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_creacion).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.piloto ? item.piloto.nombre : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.peso_tara}
                                        decimalScale={2}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
